import React, { useEffect } from 'react';
import useAuthService from '../../auth/AuthService';

const SignUp: React.FC = () => {
  const { signup } = useAuthService();

  useEffect(() => {
    signup(); // instantly redirects
  }, [signup]);

  return  <div className='loader'>
    <div className='spinner'></div>
    </div>
};

export default SignUp;